import React from 'react';
import { Pitch } from './pages/Pitch';
interface AppProps {
  /** Show the step progress rail inside the mobile Snak. */
  showProgress?: boolean;
  /** Let the "Families are funny" interlude play itself, or require a tap per line. */
  autoplayInterlude?: boolean;
}
export function App({
  showProgress = true,
  autoplayInterlude = true
}: AppProps) {
  return <Pitch showProgress={showProgress} autoplayInterlude={autoplayInterlude} data-id="element-0" data-mp="3f8eydhsi3pt5" />;
}